import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IFormFilterField, IFormFilterGroup } from '../form-filter.interface';

@Injectable()
export class FormFilterFieldsService {
    /**  Инициализация формы */
    isInitForm$ = new BehaviorSubject(false);

    /** Сетка сущностей */
    entityGrid: IFormFilterGroup[];

    /** Сетки полей  */
    fieldGrid: { [key: string]: IFormFilterField[] } = {};
}
